<template>

    <div id="mobile-navbar">

        <b-navbar toggleable="lg" variant="light">

            <b-navbar-brand href="#">
                <img src="@/assets/logo.png" class="d-inline-block align-top" alt="Norskbingo">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/">Hjem</b-nav-item>

                    <b-nav-item to="/bruksoversikt">Bruksoversikt</b-nav-item>
                    <b-nav-item to="/overforing">Sett inn</b-nav-item>

                    <b-nav-item to="/medlemskort">Kort</b-nav-item>
                    <b-nav-item to="/nytt-kort">Nytt kort</b-nav-item>

                    <b-nav-item to="/spillhaller">Spill</b-nav-item>

                    <b-nav-item to="/pause">Ta pause ifra spill</b-nav-item>
                    <b-nav-item to="/blokker" class="">Blokker deg ifra spill</b-nav-item>

                    <b-nav-item @click="handleLogout()">Logg ut</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>


    </div>

</template>

<script>

export default {
    name: 'MobileNavbar',
    methods: {
        handleLogout() {
            this.$store.clear()
            this.$router.replace({ name: "login" });
        }
    },
    computed: {
        welcomePhrase: function() {

            return "Velkommen xxx";
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >

#mobile-navbar {
    img {
        max-height:30px;
    }
}

</style>
